import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
img:string;
  constructor(private router: Router) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".intro-summary").addClass("header_active")
    if (window.location.href.indexOf("/fr/") > -1) {
      this.img="./assets/img/sumfr.png";}
  else if (window.location.href.indexOf("/es/") > -1){
    this.img="./assets/img/sumsp.png";}
    else if (window.location.href.indexOf("/pt/") > -1){
      this.img="./assets/img/sumpt.png";}
  else if(window.location.href.indexOf("/ko/")>-1){
    this.img="./assets/img/sumko.png";
  }
  else if(window.location.href.indexOf("/ar/")>-1){
    this.img="./assets/img/sumar.png";
  }
      else {
    this.img="./assets/img/colorcodes.png";}


  }

  nextBtnClick(){
    this.router.navigateByUrl('/introduction/four-element/resource')
  }
  backButtonClick(){
  	this.router.navigateByUrl('/introduction/overview')
  }
}



// WEBPACK FOOTER //
// ./src/app/introduction/summary/summary.component.ts